import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useStartExamQuery, useTogglePinMutation } from "../../Redux/Apis/userExamApi";
import Loading from "../../Layouts/Loading";
import ErrorPage from "../../Layouts/Error";
import Error404 from "../../Layouts/Error404";
import ExamHeader from "../../Sections/panel/exam/ExamHeader";
import Question from "../../Sections/panel/exam/Question";
import Directive from "../../Sections/panel/exam/Directive";
import Review from "../../Sections/panel/exam/Review";
import Help from "../../Sections/panel/exam/Help";
import { Link } from "react-router-dom";
import { useState } from 'react';
import Dictionary from "../../Components/Dictionary";
import useDoubleClick from "../../Components/useDoubleClick";
import NewTimer from "../../Components/NewTimer";
import { getSectionAndQuestionLabel } from "../../Sections/panel/exam/sectionLabel";

function Exam() {
    let {type,eId,qId} = useParams();
    const navigate = useNavigate()
    if(type === undefined || eId === undefined) navigate(`/panel/exams`)
    const examId = eId ? parseInt(eId) : 0;
    const qstId = qId ? parseInt(qId) : 0;
    if(qstId < 0) navigate(`/panel/exams`)
    const location = useLocation();

    const [hideTimer, setHideTimer] = useState(false)
    const [showDic, setShowDic] = useState<boolean>(false);
    const [popupContent, setPopupContent] = useState<string>('');
    const [resetKey,setKey] = useState(0)
    const [dir, setDir] = useState(0)
    const [review, setReview] = useState(false)
    const [help, setHelp] = useState(false)
    const [reviewSelectedOrder, setReviewSelectedOrder] = useState<number | null>(null)
    const [pin, setPin] = useState({
        status: "DELETE",
        user_exam_id: NaN,
        question_id: NaN 
    })
    const [answer, setAnswer] = useState({
        answer: "",
        user_exam_id: NaN,
        question_id: NaN 
    })

    const { data,isLoading,isSuccess,isError } = useStartExamQuery(examId, { refetchOnMountOrArgChange: true })
    const [handlePin] = useTogglePinMutation()

    // useEffect(() => {
    //     const handleBeforeUnload = (event: { preventDefault: () => void; }) => {
    //       event.preventDefault();
    //       return "data will get lost";
    //       // Custom logic to handle the refresh
    //       // Display a confirmation message or perform necessary actions
    //     };
    //     window.addEventListener('beforeunload', handleBeforeUnload);
    //     return () => {
    //       window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, []);

    const togglePin = async () => {
        setKey(resetKey + 1);
        if (pin.status === 'DELETE') {
            const res = await handlePin({...pin, status: 'CHECK'}).unwrap()
            if (res.message === 'checked') setPin(pin => ({...pin, status: 'CHECK'}))
        }
        else if(pin.status === 'CHECK') {
            const res = await handlePin({...pin, status: 'DELETE'}).unwrap()
            if (res.message === 'deleted') setPin(pin => ({...pin, status: 'DELETE'}))
        }
    }

    const handleDoubleClick = (event: MouseEvent) => {
        const selection = window.getSelection();
        const selectedText = selection ? selection.toString().trim() : '';
        const { pathname } = location;
        if (selectedText && pathname.includes('/test/')) {
            setPopupContent(selectedText);
            setShowDic(true);
        }
    };
    useDoubleClick(handleDoubleClick);


    const renderSectionAndQuestionLabel = (type: string, qstId: number, totalQuestions: number) => {
        const { sectionLabel, questionLabel } = getSectionAndQuestionLabel(type, qstId, totalQuestions);
        return (
            <h6 className="m-0 p-0 d-inline">
            {`Section ${sectionLabel}`} |{' '}
            <span className="fw-light">{`Question ${questionLabel}`}</span>
            </h6>
        );
    }

    if(isLoading)
        return <Loading/>

    else if(isError)
        return <ErrorPage/>

    else if(isSuccess && data) {
        if (data.credit === false) 
            return (
                <div className="alert alert-danger text-center my-5" role="alert">
                    <h4 className="alert-heading"><FontAwesomeIcon icon="circle-exclamation" className="me-2"/>اعتبار ناکافی!</h4>
                    <p>شما اعتبار مورد نیاز برای شرکت در آزمون جدید ندارید! لطفا ابتدا حساب خود را شارژ نمایید.</p>
                    <hr />
                    <p className="mb-0">جهت افزایش اعتبار از بخش <Link to="/panel/package" className="alert-link">اشتراک ها</Link> اقدام نمایید.</p>
                </div>)
      
        return ( 
            <>
                <ExamHeader 
                    type={type} 
                    title={data.exam.name} 
                    id={data.exam.id} 
                    index={qstId} 
                    end={data.exam._count.Questions} 
                    answer={answer} 
                    info={data?.exam?.note}
                    userExam={data.userExam.id}
                    resetKey={resetKey}
                    setKey={setKey}
                    examType={data.exam.type}
                    dir={dir}
                    setDir={setDir}
                    pin={pin}
                    togglePin={togglePin}
                    examOrder={data.exam.order}
                    review={review}
                    setReview={(value:any) => {
                        // هنگام ورود به Review، سوال فعلی را به صورت پیش‌فرض انتخاب کن
                        setReviewSelectedOrder(qstId)
                        if (typeof value === "function") {
                            setReview((prev) => value(prev))
                        } else {
                            setReview(value)
                        }
                    }}
                    reviewSelectedOrder={reviewSelectedOrder}
                    help={help}
                    setHelp={setHelp}
                />
                <div dir="ltr" className="p-0 m-0">
                    <div className="d-flex justify-content-between align-items-center pt-2 pb-2 m-0 px-5 border-bottom border-danger border-2">
                        <div>
                            <FontAwesomeIcon icon="check-square" className="ms-1"/>
                            {renderSectionAndQuestionLabel(data.exam.type, qstId, data.exam._count.Questions)}
                        </div>
                        <div>
                            {type === "real" ? 
                                <h6 className={`m-0 p-0 ${hideTimer ? "d-none" : "d-inline"}`}><NewTimer id={`timer-${data.userExam.id}-real`} durationInSeconds={data.exam.time * 60} isCountUp={false} type={data.exam.type} order={data.exam.order}/></h6> 
                                : 
                                <h6 className={`m-0 p-0 ${hideTimer ? "d-none" : "d-inline"}`}><NewTimer id={`timer-${data.userExam.id}-test`} durationInSeconds={data.exam.time * 60} isCountUp={true}/></h6>
                            }
                            <FontAwesomeIcon icon="clock" className={`me-1 ${hideTimer ? "d-none" : "d-inline"}`}/>
                            <span role="button" className="d-inline m-0 p-0 pe-1 fw-light text-decoration-underline text-primary" onClick={() => setHideTimer(hideTimer => !hideTimer)}>{hideTimer ? "Show Time" : "Hide Time"}</span>
                        </div>
                    </div>
                    <div className="h-100 border rounded m-1 p-2 text-center" id="exam_body" key={resetKey}>
                        {review ? (
                            <Review
                                userExamId={data.userExam.id}
                                type={type}
                                id={data.exam.id}
                                examType={data.exam.type}
                                dir={dir}
                                section={
                                    data.exam.type === 'GENERAL'
                                        ? Math.ceil(qstId / 20)
                                        : data.exam.type === 'GENERAL2'
                                        ? Math.floor((qstId - 1) / 20)
                                        : data.exam.type === 'GENERAL1'
                                        ? qstId === 1
                                            ? 0
                                            : qstId <= 13
                                            ? 1
                                            : qstId <= 25
                                            ? 2
                                            : qstId <= 41
                                            ? 3
                                            : 4
                                        : -1
                                }
                                selectedOrder={reviewSelectedOrder}
                                onSelect={setReviewSelectedOrder}
                            />
                        ) : help ? (
                            <Help
                                examType={data.exam.type}
                                questionsCount={data.exam._count.Questions}
                                minutes={data.exam.time}
                            />
                        ) : (
                            <>
                                {dir >= 0 || qId === '0' ? 
                                    <Directive section={qId === '0' ? 0 : dir} type={data.exam.type} time={data.exam.time} count={data.exam._count.Questions} examOrder={data.exam.order}/>
                                    :
                                    <Question examId={examId} qstId={qstId} userExam={data.userExam.id} answer={answer} setAnswer={setAnswer} resetKey={resetKey} setPin={setPin}/>
                                }
                            </>
                        )}
                    </div>
                </div>
                {showDic && (
                    <Dictionary
                    content={popupContent}
                    onClose={() => setShowDic(false)}
                    />
                )}
            </>
        );
    }

    else return <Error404/>
}

export default Exam;
